import type {
  InboxWorkflowCellComponent,
  InboxWorkflowFlowConfig,
} from "@kontextwerk/control-web-frame/inbox-workflow/contract"
import {
  buildFlowSteps,
  withHelp,
  workflowDefinition,
  workflowStep,
} from "../../_shared/_logic/registry-composition"
import { inboxWorkflowHelpDialogIds } from "../../_shared/_logic/help-dialog-ids"
import {
  createReviewContactPointsStep,
  reviewContactPointCells,
} from "./steps/01_review_contact_points"
import { createSourceCleanupStep, sourceCleanupCells } from "./steps/02_source_cleanup"

export const customerContactPointReviewCells: Record<string, InboxWorkflowCellComponent> = {
  ...reviewContactPointCells,
  ...sourceCleanupCells,
}

export const customerContactPointReviewFlow: InboxWorkflowFlowConfig = {
  definition: workflowDefinition({
    flowKey: "customer_contact_point_review",
    label: "Kontaktdaten prüfen",
    subjectPolicy: "OPTIONAL",
    requirements: ["REVIEW_CONTACT_POINT", "UPDATE_SOURCE_CONTACT_DATA"],
    steps: [
      workflowStep({
        stepKey: "review_contact_points",
        label: "Kontaktdaten prüfen",
        componentKey: "customer_contact_point_review.review_contact_points",
        requirements: ["REVIEW_CONTACT_POINT"],
        outputKey: "contact_points",
      }),
      workflowStep({
        stepKey: "source_cleanup",
        label: "Im Kehrbezirksprogramm nachtragen",
        componentKey: "shared.source_cleanup",
        requirements: ["UPDATE_SOURCE_CONTACT_DATA"],
        outputKey: "source_cleanup",
      }),
    ],
  }),
  steps: buildFlowSteps({
    review_contact_points: withHelp(
      createReviewContactPointsStep(),
      inboxWorkflowHelpDialogIds.customerContactPointReview,
    ),
    source_cleanup: withHelp(
      createSourceCleanupStep(),
      inboxWorkflowHelpDialogIds.customerContactPointReviewSourceCleanup,
    ),
  }),
}
